import React from "react";
import { GridCellProps } from "@progress/kendo-react-grid";
import { getScoreStyle } from "../utils/scoreColors";
import type { TrustCallPhone } from "../types";

interface AppScoreCellProps extends GridCellProps {
  onDetailsClick?: (phone: TrustCallPhone) => void;
}

const AppScoreCell: React.FC<AppScoreCellProps> = (props) => {
  const dataItem = props.dataItem as TrustCallPhone;
  const value = dataItem.appScore ?? "";
  const style = getScoreStyle(value);

  return (
    <td>
      <span style={style}>{value}</span>
      {value === "Flagged" && props.onDetailsClick && (
        <>
          <br />
          <button
            className="btn btn-dark btn-sm"
            style={{ fontSize: "0.7rem", padding: "2px 8px" }}
            onClick={() => props.onDetailsClick!(dataItem)}
          >
            Details
          </button>
        </>
      )}
    </td>
  );
};

export default AppScoreCell;
